export const getDownloadFileName = (response: Response, fallback: string): string => {
  const disposition = response.headers.get('content-disposition') || '';
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  const basicMatch = disposition.match(/filename="?([^";]+)"?/i);
  const candidate = utf8Match?.[1] || basicMatch?.[1];

  if (!candidate) return fallback;

  try {
    return decodeURIComponent(candidate.trim());
  } catch {
    return candidate.trim();
  }
};
